export default __webpack_public_path__ + "static/media/detail.30c62800.svg";